import { useEffect, useState } from "react";
import seloMG from "../../assets/img/Selo Minas Gerais 2024.png";
import seloM1 from "../../assets/img/Selo-M-1.png";
import selo from "../../assets/img/SeloGPTW2025.png";
import seloMental from "../../assets/img/Certificada Mental Health.jpg";
import seloGovInv from "../../assets/img/SeloGov.png";
import seloGovCorp from "../../assets/img/Selo Governanca.png";
import seloBureau from "../../assets/img/Selo ISO 31000.png";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import "./styles.css";

interface SeloBase {
  id: number;
  title: string;
  image: string;
}
interface SeloNormal extends SeloBase {
  url?: undefined;
}
interface SeloComPDF extends SeloBase {
  url: string;
}
type Selo = SeloNormal | SeloComPDF;
interface SeloItemProps {
  item: Selo;
  className?: string;
}
interface ConquistasProps {
  removeBackground?: boolean;
  compact?: boolean;
}

const Conquistas = ({ removeBackground = false, compact = false }: ConquistasProps) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [isExtraSmall, setIsExtraSmall] = useState(window.innerWidth < 480);

  useEffect(() => {
    const handleResize = () => {
      const ismobile = window.innerWidth < 992;
      const isxsmall = window.innerWidth < 480;
      if (ismobile !== isMobile) setIsMobile(ismobile);
      if (isxsmall !== isExtraSmall) setIsExtraSmall(isxsmall);
    };

    window.addEventListener("resize", handleResize, false);

    return () => {
      window.removeEventListener("resize", handleResize, false);
    }
  }, [isMobile, isExtraSmall]);

  const todosOsSelos: Selo[] = [
    {
      id: 1,
      title: "Certificada Mental Health",
      image: seloMental,
    },
    {
      id: 2,
      title: "Certificação de Excelência",
      image: selo,
    },
    {
      id: 3,
      title: "Selo M1",
      image: seloM1,
    },
    {
      id: 4,
      title: "Selo Minas Gerais 2024",
      image: seloMG,
    },
    {
      id: 5,
      title: "Certificação Bureau Veritas",
      image: seloBureau,
      url: "/docs/certificados/Certificado - Sistema de Gestão de Riscos.pdf"
    },
    {
      id: 6,
      title: "Selo Governança de Investimentos",
      image: seloGovInv,
      url: "/docs/certificados/Selo Governança de Investimentos - FORLUZ.pdf"
    },
    {
      id: 7,
      title: "Selo Governança Corporativa",
      image: seloGovCorp,
      url: "/docs/certificados/Selo Governança Corporativa.pdf"
    },
  ];

  const SeloItem = ({ item, className = "" }: SeloItemProps) => (
    <div className={`selo-item ${className} ${item.url ? 'has-link' : ''}`}>
      {item.url ? (
        <a href={item.url} target="_blank" rel="noreferrer">
          <div className="selo-image">
            <img
              src={item.image}
              alt={item.title}
              onError={(e) => {
                console.error(`Erro ao carregar imagem: ${item.title}`);
                e.currentTarget.style.display = 'none';
                if (e.currentTarget.parentElement) {
                  e.currentTarget.parentElement.innerHTML +=
                    `<div style="padding: 20px; text-align: center; color: #888;">
                        <p>Imagem não disponível</p>
                        <p>${item.title}</p>
                    </div>`;
                }
              }}
            />
          </div>
        </a>
      ) : (
        <>
          <div className="selo-image">
            <img
              src={item.image}
              alt={item.title}
              onError={(e) => {
                console.error(`Erro ao carregar imagem: ${item.title}`);
                e.currentTarget.style.display = 'none';
                if (e.currentTarget.parentElement) {
                  e.currentTarget.parentElement.innerHTML +=
                    `<div style="padding: 20px; text-align: center; color: #888;">
                        <p>Imagem não disponível</p>
                        <p>${item.title}</p>
                    </div>`;
                }
              }}
            />
          </div>
        </>
      )}
    </div>
  );

  const renderSelosLayout = () => {

    return (
      <div className="selos-container">
        <div className="selos-row primeira-linha">
          {todosOsSelos.map(item => (
            <div key={item.id} className="selo-wrapper">
              <SeloItem item={item} className="selo-item" />
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="conquistas-container-full conquistas-compact conquistas-transparent" >
      {renderSelosLayout()}
    </div>
  );
};

export default Conquistas;